import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as firebase from "firebase";
import config from './config'

firebase.initializeApp({
  apiKey: config.apiKey,
  projectId: config.projectId,
  authDomain: config.authDomain,
  storageBucket: config.storageBucket
});

firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
});

firebase.firestore().enablePersistence({ synchronizeTabs: true }).catch((err) => {
  console.error("Persistence failed:", err.code);
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
